// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbh_a"};